import {PALETTE_IDS} from '#core/application/modules/ids.js';

import {COLOR, FONT} from '../theme.js';

export function getRacingConfig() {
    return {
        custom: {
            [PALETTE_IDS.RACE_MEETINGS]: {
                RaceMeeting: {
                    description: {
                        style: {
                            _mobile_alignItems: 'center',
                        },
                    },
                },
            },
        },
        palette: {
            [PALETTE_IDS.RACE_CARD]: {
                // info with description
                RACE_CARD_INFO_HEADER_BG: COLOR.BRAND.BACKGROUND5,
                RACE_CARD_INFO_TITLE_TEXT: {
                    color: COLOR.BRAND.FOREGROUND5,
                    fontSize: FONT.SIZE_MEDIUM,
                    fontWeight: FONT.WEIGHT_BOLD,
                },
                RACE_CARD_INFO_RUNNERS_AMOUNT_TEXT: {
                    color: COLOR.BRAND.FOREGROUND2,
                    fontSize: FONT.SIZE_XXSMALL,
                },
                RACE_CARD_INFO_STREAMING_INDICATOR: {
                    INDICATOR_ICON_COLOR: COLOR.BRAND.FOREGROUND5,
                },
                RACE_CARD_RUNNERS_TABLE: {
                    TABLE_HEADER_TEXT: COLOR.BRAND.FOREGROUND1,
                    TABLE_HEADER_SORT_BUTTON_TEXT: {
                        color: COLOR.BRAND.ACCENT2,
                        fontWeight: FONT.WEIGHT_NORMAL,
                    },
                    TABLE_HEADER_SORT_BUTTON_ICON_SRC: 'sort-desc-smooth-edges',
                },
                RACE_CARD_CAST_MARKETS_TABLE: {
                    TABLE_HEADER_BG: COLOR.BRAND.BACKGROUND2,
                    TABLE_HEADER_TEXT: COLOR.BRAND.FOREGROUND2,
                },
                RACE_CARD_INFO_RACE_NUMBER_TEXT: '#c9ccd1',
                // Zeplin styles, but have to comment it because of Mojito bug with racing table
                // RACE_CARD_RUNNERS_TABLE: {
                //     // TABLE_HEADER_TEXT: COLOR.BRAND.FOREGROUND2,
                //     // TABLE_HEADER_BG: COLOR.BASE.DIVIDER,
                // },
            },
            [PALETTE_IDS.RACE_MEETINGS]: {
                RACE_MEETINGS_HEADER_BG: COLOR.BRAND.BACKGROUND5,
                RACE_MEETINGS_HEADER_TEXT: {
                    color: COLOR.BRAND.FOREGROUND4,
                    textTransform: 'uppercase',
                },
                RACE_MEETINGS_WATCH_LIVE_BUTTON: {
                    SECONDARY_BUTTON_SELECTED_BG: COLOR.BRAND.FOREGROUND3,
                },
                RACE_MEETINGS_RACE_BUTTON: {
                    TOGGLE_BUTTON_TEXT: COLOR.BRAND.ACCENT1,
                },
                RACE_MEETING_MOBILE_RACE_TIME_SELECTOR_BG: COLOR.BRAND.BACKGROUND5,
                RACE_MEETINGS_EXPLANATION_TEXT: COLOR.RESERVED.WHITE,
                RACE_MEETINGS_RACING_PRICE_ICON_COLOR: COLOR.BRAND.FOREGROUND3,
            },
        },
    };
}
